import React, { Component } from 'react'
import TextField from '@material-ui/core/TextField';
import InputAdornment from '@material-ui/core/InputAdornment';
import SearchIcon from '@material-ui/icons/Search';

class Search  extends Component {

    state = { value: '' }

    onchange = (search) => {
        const value = search.target.value || ''
        
        this.setState({ value });
        this.props.onSearchchanged(value);
    }

    render() {
        return (
           <form onSubmit={(e) => e.preventDefault()} >
                <TextField 
                    id="search" 
                    InputProps={{ 
                        inputProps: { tabIndex: -1},
                        startAdornment: (
                            <InputAdornment position="start">
                                <SearchIcon color='disabled' />
                            </InputAdornment>
                        ),
                    }} 
                    value={this.state.value} 
                    placeholder="Transaction Search" 
                    onChange={this.onchange} />
                <i className="fas fa-times light" style={{ color: '#ccc' }} onClick={this.onchange}></i>
            </form>
        );
    }
}

export default Search


// WEBPACK FOOTER //
// ./src/components/TransactionsMenu/Search.js